const DELIVERY_METHOD={hosted:"Provisioned",inVpc:"In-VPC",onPrem:"On-Prem",serverless:"Serverless"};export{DELIVERY_METHOD};
